var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.value !== null && _vm.value === 'false')?_c('RadioboxBlankIcon'):_vm._e(),_vm._v(" "),(_vm.value !== null && _vm.value === 'true')?_c('CheckCircleOutline'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }